'use client';

import type { ReactNode } from 'react';
import { Currency } from 'utils/Currency';
import type { InstallmentConfig } from 'utils/installmentConfig';
import { PriceDisplay } from './PriceDisplay';
import { PaymentOptions, type PaymentOptionsData } from './PaymentOptions';
import { DispatchInfo } from './DispatchInfo';
import styles from './ProductHeading.module.css';

export type ProductHeadingProps = {
  title: ReactNode;
  tagline?: ReactNode;
  price: number;
  strikedPrice?: number;
  currency: Currency;
  installmentConfig?: InstallmentConfig | null;
  splitPaymentsDisplay?: PaymentOptionsData | null;
  dispatchDate?: string | null;
  onSeeAllPaymentOptions?: () => void;
};

export const ProductHeading = ({
  title,
  tagline,
  price,
  strikedPrice,
  currency,
  installmentConfig,
  splitPaymentsDisplay,
  dispatchDate,
  onSeeAllPaymentOptions,
}: ProductHeadingProps) => {
  return (
    <div className={styles.container}>
      <h2>{title}</h2>
      {tagline ? <p className={styles.description}>{tagline}</p> : null}
      <PriceDisplay
        price={price}
        strikedPrice={strikedPrice}
        currency={currency}
        installmentConfig={installmentConfig}
      />
      {splitPaymentsDisplay ? (
        <PaymentOptions
          data={splitPaymentsDisplay}
          onSeeAll={onSeeAllPaymentOptions}
        />
      ) : null}
      {dispatchDate ? <DispatchInfo date={dispatchDate} /> : null}
    </div>
  );
};
